namespace GeniuzPOS.AdvPromo {
    export namespace AdvancedPromoReportService {
        export const baseUrl = 'AdvPromo/AdvancedPromoReport';

        export declare function Create(request: Serenity.SaveRequest<AdvancedPromoReportRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<AdvancedPromoReportRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<AdvancedPromoReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AdvancedPromoReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/AdvancedPromoReport/Create",
            Update = "AdvPromo/AdvancedPromoReport/Update",
            Delete = "AdvPromo/AdvancedPromoReport/Delete",
            Retrieve = "AdvPromo/AdvancedPromoReport/Retrieve",
            List = "AdvPromo/AdvancedPromoReport/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>AdvancedPromoReportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
